import {TRAINING_FEATURE_FLAG_PREFIX} from '../../../../lib/training.mjs';
import {useUserProfile} from '../api.js';
import FeatureFlag from './FeatureFlag.jsx';

export default function FeatureFlags() {
  const {data: user} = useUserProfile();

  const attributes = Object.keys(user.attributes).filter(attr =>
    attr.includes(TRAINING_FEATURE_FLAG_PREFIX)
  );

  return (
    <div>
      <h2 className="mb-2 border-b border-base-200 text-sm">Feature flags</h2>

      <div className="divide-y divide-base-200 dark:divide-base-100">
        {attributes.map(attr => (
          <FeatureFlag key={attr} attr={attr} />
        ))}
      </div>
    </div>
  );
}
